export default {
    topics: [
        {
            title: ' batchDelete ',
            href: 'm-DBEngine-batchDelete.html',
            attributes: { 'data-id': 'm-DBEngine-batchDelete' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-batchDelete-d66e5651',
            topics: [],
        },
        {
            title: ' begin ',
            href: 'm-DBEngine-begin.html',
            attributes: { 'data-id': 'm-DBEngine-begin' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-begin-d66e5659',
            topics: [],
        },
        {
            title: ' commit ',
            href: 'm-DBEngine-commit.html',
            attributes: { 'data-id': 'm-DBEngine-commit' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-commit-d66e5667',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-DBEngine-dispose.html',
            attributes: { 'data-id': 'm-DBEngine-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-dispose-d66e5675',
            topics: [],
        },
        {
            title: ' exec ',
            href: 'm-DBEngine-exec.html',
            attributes: { 'data-id': 'm-DBEngine-exec' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-exec-d66e5683',
            topics: [],
        },
        {
            title: ' execute ',
            href: 'm-DBEngine-execute.html',
            attributes: { 'data-id': 'm-DBEngine-execute' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-execute-d66e5691',
            topics: [],
        },
        {
            title: ' isBroken ',
            href: 'p-DBEngine-isBroken.html',
            attributes: { 'data-id': 'p-DBEngine-isBroken' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isBroken-d66e5699',
            topics: [],
        },
        {
            title: ' isDB2 ',
            href: 'p-DBEngine-isDB2.html',
            attributes: { 'data-id': 'p-DBEngine-isDB2' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isDB2-d66e5707',
            topics: [],
        },
        {
            title: ' isMSSQL ',
            href: 'p-DBEngine-isMSSQL.html',
            attributes: { 'data-id': 'p-DBEngine-isMSSQL' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isMSSQL-d66e5715',
            topics: [],
        },
        {
            title: ' isMySQL ',
            href: 'p-DBEngine-isMySQL.html',
            attributes: { 'data-id': 'p-DBEngine-isMySQL' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isMySQL-d66e5723',
            topics: [],
        },
        {
            title: ' isOracle ',
            href: 'p-DBEngine-isOracle.html',
            attributes: { 'data-id': 'p-DBEngine-isOracle' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isOracle-d66e5732',
            topics: [],
        },
        {
            title: ' isPostgreSQL ',
            href: 'p-DBEngine-isPostgreSQL.html',
            attributes: { 'data-id': 'p-DBEngine-isPostgreSQL' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isPostgreSQL-d66e5740',
            topics: [],
        },
        {
            title: ' isSybase ',
            href: 'p-DBEngine-isSybase.html',
            attributes: { 'data-id': 'p-DBEngine-isSybase' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isSybase-d66e5748',
            topics: [],
        },
        {
            title: ' isSybaseIQ ',
            href: 'p-DBEngine-isSybaseIQ.html',
            attributes: { 'data-id': 'p-DBEngine-isSybaseIQ' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-isSybaseIQ-d66e5756',
            topics: [],
        },
        {
            title: ' query ',
            href: 'm-DBEngine-query.html',
            attributes: { 'data-id': 'm-DBEngine-query' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-query-d66e5764',
            topics: [],
        },
        {
            title: ' queryWithTypes ',
            href: 'm-DBEngine-queryWithTypes.html',
            attributes: { 'data-id': 'm-DBEngine-queryWithTypes' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-queryWithTypes-d66e5772',
            topics: [],
        },
        {
            title: ' rollback ',
            href: 'm-DBEngine-rollback.html',
            attributes: { 'data-id': 'm-DBEngine-rollback' },
            menu: { hasChildren: false },
            tocID: 'm-DBEngine-rollback-d66e5780',
            topics: [],
        },
        {
            title: ' useNChar ',
            href: 'p-DBEngine-useNChar.html',
            attributes: { 'data-id': 'p-DBEngine-useNChar' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-useNChar-d66e5788',
            topics: [],
        },
        {
            title: ' useUnicodeData ',
            href: 'p-DBEngine-useUnicodeData.html',
            attributes: { 'data-id': 'p-DBEngine-useUnicodeData' },
            menu: { hasChildren: false },
            tocID: 'p-DBEngine-useUnicodeData-d66e5796',
            topics: [],
        },
    ],
};

